import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Säästad kokku <span style="color:#a6d189;">**{percent}**</span>

  <span style="color:#85c1dc;">**FI:**</span>
  Säästät yhteensä <span style="color:#a6d189;">**{percent}**</span>

  <span style="color:#85c1dc;">**RU:**</span>
  Всего Вы экономите <span style="color:#a6d189;">**{percent}**</span>
*/
/* @__NO_SIDE_EFFECTS__ */
const m540 = msg(
  mf`Säästad kokku ${'percent'}`,
  mf`Säästät yhteensä ${'percent'}`,
  mf`Всего Вы экономите ${'percent'}`,
)

export { m540 as 'w.basket.summary.total_saved' }